import React from "react";

function SmartConDevHero() {
  return (
    <div>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Custom Smart Contract Development
                </h2>
                <div className="info">
                  <p className="fade-up-anim">
                    Empower your business with Xeer Technology’s specialized
                    smart contract services, delivering tailored solutions that
                    automate processes, enhance security, and drive innovation
                    across industries.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SmartConDevHero;
